import { Navigate } from "react-router";

import { useFlags } from "launchdarkly-react-client-sdk";

import { useUserContext } from "sj-ui-toolkit/src/atlas/contexts/User/UserContextProvider";

import AspenChatBeta from "./AspenChatBeta";
import AspenChatLegacy from "./AspenChatLegacy";

export default function AspenChatPage() {
  const { aspenTenantAdminChat, aspenChatNewUi } = useFlags();
  const { isTenantAdmin } = useUserContext();

  if (!aspenTenantAdminChat || !isTenantAdmin) {
    return <Navigate to="/" replace />;
  }

  return aspenChatNewUi ? <AspenChatBeta /> : <AspenChatLegacy />;
}
